/**
 * The background track: an audio file, played straight.
 *
 * This was a YouTube embed first, which could not be reached — and an embedded
 * player was always a lot of machinery for something that is only ever sound.
 * A plain audio element loops a file with no third party involved, no network
 * once it is cached, and nothing to go wrong offline.
 */
export interface Track {
  play(): Promise<void>;
  pause(): void;
  setVolume(value: number): void;
  load(url: string): void;
  destroy(): void;
}

/** The track that ships with the app, so there is something to press play on. */
export const DEFAULT_TRACK = '/audio/ambience.mp3';

export function createTrack(url: string, volume: number): Track {
  const audio = new Audio(url);
  audio.loop = true;
  audio.volume = clamp(volume);
  audio.preload = 'auto';

  return {
    play: () => audio.play(),
    pause: () => audio.pause(),
    setVolume: (value) => {
      audio.volume = clamp(value);
    },
    load: (next) => {
      if (audio.src.endsWith(next)) return;
      audio.src = next;
      audio.load();
    },
    destroy: () => {
      audio.pause();
      audio.removeAttribute('src');
      audio.load();
    },
  };
}

function clamp(value: number): number {
  return Math.min(1, Math.max(0, value));
}
